import { useEffect } from 'react';
import { PageSeo, seoDefaults } from '../data/seo';
import { removeJsonLd, setCanonical, setHtmlLang, setJsonLd, setMetaName, setMetaProperty, setTitle } from '../utils/head';
interface SeoProps extends PageSeo {
  /** Structured data blocks, keyed so they can be swapped per route. */
  jsonLd?: {
    id: string;
    data: unknown;
  }[];
}
export function Seo({
  title,
  description,
  path,
  keywords,
  image,
  imageAlt,
  jsonLd = []
}: SeoProps) {
  useEffect(() => {
    const url = `${seoDefaults.siteUrl}${path}`;
    const ogImage = image ?? seoDefaults.ogImage;
    setHtmlLang('en');
    setTitle(title);
    setMetaName('description', description);
    setMetaName('keywords', keywords);
    setMetaName('robots', 'index, follow, max-image-preview:large');
    setMetaName('author', seoDefaults.siteName);
    setMetaName('theme-color', seoDefaults.themeColor);
    setMetaName('format-detection', 'telephone=no');
    setCanonical(url);
    setMetaProperty('og:site_name', seoDefaults.siteName);
    setMetaProperty('og:type', path === '/' ? 'website' : 'article');
    setMetaProperty('og:locale', seoDefaults.locale);
    setMetaProperty('og:title', title);
    setMetaProperty('og:description', description);
    setMetaProperty('og:url', url);
    setMetaProperty('og:image', ogImage);
    setMetaProperty('og:image:alt', imageAlt ?? seoDefaults.siteName);
    setMetaName('twitter:card', 'summary_large_image');
    setMetaName('twitter:site', seoDefaults.twitterHandle);
    setMetaName('twitter:title', title);
    setMetaName('twitter:description', description);
    setMetaName('twitter:image', ogImage);
    setMetaName('twitter:image:alt', imageAlt ?? seoDefaults.siteName);
    jsonLd.forEach(block => setJsonLd(block.id, block.data));
    const ids = jsonLd.map(block => block.id);
    return () => ids.forEach(removeJsonLd);
  }, [title, description, path, keywords, image, imageAlt, jsonLd]);
  return null;
}